module.exports = __webpack_public_path__ + "static/media/icon-arrow-bottom.671f3102.svg";